<template>
  <div class="mt-6 log-tabs">
    <GoodTableVue
      :rows="listDuoCareLog"
      :columns="columns"
      :lineNumbers="{ show: false }"
      height="500px"
      :noneBorder="true"
    >
      <template #typeCurriculum="item">
        <span style="padding:5px 10px; border-radius:5px; color: #fff" :style="{background:TYPE_CURRICULUM_TAG[`${item.typeCurriculum}`].color}">
          {{ TYPE_CURRICULUM_TAG[`${item.typeCurriculum}`].text }}
        </span>
      </template>
      <template #description="item">
        <div class="py-2">
          <span v-html="convertPrograme(item)"></span>
        </div>
      </template>
    </GoodTableVue>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BlendedCareServices from '@/services/BlendedCareRepository';
import { contactCreator, TYPE_CURRICULUM_TAG } from '@/helpers/constant';
import GoodTableVue from '@/components/common/GoodTable.vue';
import StudentCareServices from '@/services/StudentCareServices';

export default {
  components: { GoodTableVue },
  data() {
    return {
      contactCreator,
      TYPE_CURRICULUM_TAG,
      listDuoCareLog: [],
      columns: [
        {
          label: 'Thời gian',
          field: 'createdAt',
          type: 'date',
          format: 'YYYY-MM-DD HH:mm',
          tdClass: 'text-center',
          thWidth: '170px',
        },
        {
          label: 'Người thực hiện',
          field: 'creatorFullName',
          thWidth: '200px',
        },
        {
          label: 'Module',
          field: 'typeCurriculum',
          customRow: true,
          thWidth: '180px',
        },
        {
          label: 'Mô tả',
          field: 'description',
          customRow: true,
          thWidth: '700px',
        },
      ],
      filterType: {
        1: null, 2: 'online', 3: 'duo', 4: 'blended_tutor',
      },
      filterTypeBlended: {
        2: 'blended_tutor', 4: 'blended_station',
      },
    };
  },
  computed: {
    ...mapState('student_detail_bt', ['activeFilterType', 'filterForm', 'studentBlendedTutorDetail']),
  },
  async created() {
    await this.getLogDuoCare();
  },
  watch: {
    activeFilterType(val) {
      if (val) {
        this.getLogDuoCare();
      }
    },
    'filterForm.dateTime': {
      handler() {
        this.getLogDuoCare();
      },
    },
  },
  methods: {
    ...mapActions('student_care', ['getContactLogs']),
    async getLogDuoCare() {
      this.listDuoCareLog = [];
      const [careHistoriesDetail, logContact, logTask] = await Promise.all([
        this.getAllHistoryCare({
          ...this.studentBlendedTutorDetail,
          type_customer_care: undefined,
        }),
        this.getContactLogs(this.studentBlendedTutorDetail.contact_id),
        this.getListLogTask(),
      ]);
      const careHistoriesDetailForLog = careHistoriesDetail.filter(
        (e) => e.created_by === 100004 || e.type_customer_care === null,
      );
      if (this.filterForm.dateTime && this.filterForm.dateTime.length) {
        const startDate = new Date(`${this.filterForm.dateTime[0]} 00:00:00`);
        const endDate = new Date(`${this.filterForm.dateTime[1]} 23:59:59`);

        const logContactDay = logContact.filter((item) => {
          const date = new Date(item.createdAt);
          return date >= startDate && date <= endDate;
        });
        this.renderListDuoCareLog(careHistoriesDetailForLog, logContactDay, logTask);
      } else {
        this.renderListDuoCareLog(careHistoriesDetailForLog, logContact, logTask);
      }
    },
    renderListDuoCareLog(careHistoriesDetailForLog, logContact, logTask) {
      if (this.activeFilterType === 1) {
        const logs = [...careHistoriesDetailForLog, ...logContact, ...logTask].map((e) => ({
          creatorFullName:
          this.convertText(e?.creator?.fullName)
          || this.convertText(e?.created_name)
          || this.convertText(contactCreator[e?.createdBy]),
          description: e?.note || e?.description || e?.content,
          createdAt: e.created_at || e.createdAt,
          typeCurriculum: (e.type_curriculum || e.type_blended) ? this.checktypeCurriculum(e) : 'crm',
        }));
        this.listDuoCareLog = _.orderBy(logs, ['createdAt'], ['desc']);
      } else {
        const logs = [...careHistoriesDetailForLog, ...logTask].map((e) => ({
          creatorFullName:
          this.convertText(e?.creator?.fullName)
          || this.convertText(e?.created_name)
          || this.convertText(contactCreator[e?.createdBy]),
          description: e?.note || e?.description || e?.content,
          createdAt: e.created_at || e.createdAt,
          typeCurriculum: (e.type_curriculum || e.type_blended) ? this.checktypeCurriculum(e) : 'crm',
        }));
        this.listDuoCareLog = _.orderBy(logs, ['createdAt'], ['desc']);
      }
    },
    checktypeCurriculum(e) {
      if (e.type_blended === null) {
        return e.type_curriculum;
      }
      return this.filterTypeBlended[`${e.type_blended}`];
    },
    async getAllHistoryCare(params) {
      const body = {
        obj: 'call-histories-detail',
        attrs: [
          'id',
          'created_name',
          'note',
          'call_name',
          'call_status_name',
          'call_status_id',
          'call_id',
          'created_at',
          'created_by',
          'type_customer_care',
          'type_curriculum',
          'type_blended',
        ],
        'filters[$eq__lms_core_user_id]': params.lms_core_user_id,
        'filters[$eq__type_customer_care]': params.type_customer_care,
        'sorts[created_at]': 'desc',
        'filters[$between__created_at]': this.filterForm.dateTime && this.filterForm.dateTime.length ? `['${this.filterForm.dateTime[0]} 00:00:00' , '${this.filterForm.dateTime[1]} 23:59:59']` : null,
      };
      if (this.activeFilterType === 2) {
        const data = { ...body, 'filters[$in__type_curriculum]': [this.filterType[`${this.activeFilterType}`], this.filterType[`${this.activeFilterType * 2}`]] };
        const res = await BlendedCareServices.fgGetListCare(data);
        if (res?.success) {
          return res?.data;
        }
      } else {
        const data = { ...body, 'filters[$eq__type_curriculum]': this.filterType[`${this.activeFilterType}`] };
        const res = await BlendedCareServices.fgGetListCare(data);
        if (res?.success) {
          return res?.data;
        }
      }
      return [];
    },
    convertText(text) {
      const array = ['Log hệ thống', 'Hệ thống BOT'];
      if (array.includes(text)) {
        return 'Hệ thống';
      }
      return text;
    },
    convertPrograme(item) {
      const regex = /TA/g;
      if (item.typeCurriculum === 'blended_tutor') {
        return item.description.replace(regex, 'BT');
      }
      return item.description;
    },
    async getListLogTask() {
      const res = await StudentCareServices.getLogTask({
        lms_core_user_id: this.studentBlendedTutorDetail.lms_core_user_id,
      });
      if (res && res.data) {
        return res.data;
      }
      return [];
    },
  },
};
</script>

<style lang='scss' scoped>
.log-tabs {
  height: 560px;
}

</style>
